module.exports = __webpack_public_path__ + "static/media/toolbar_closetool.4befec68.png";